import { connect } from 'react-redux';
import { actionCreators } from './actions';
import { HeaderPanelProps } from 'app/components/case-header-panel';
import { ComplexValue } from 'ui';
import { ConnectedCaseActionTypes } from 'app/components/connect-existing-cases/connect-existing-cases';

export const withCallsToActions = (component: any) => {

  const dispatchToProps = (dispatch: any): Partial<HeaderPanelProps> => {
    return {
      callsToActions: (caseId: number) => 
        dispatch(actionCreators.callsToActions(caseId)),
      
      onChangeCaseStatus: (caseId: number, status: ComplexValue<number>, allowWarnings: boolean = true) => 
        dispatch(actionCreators.onChangeCaseStatus(caseId, status, allowWarnings)),

      onChangeCaseConnection: ({ caseId, connectedCaseId, connectionTypeId,
        currentConnectedCases, allowWarnings = true, type, bowtie = false, instanceKey
      }: {
        caseId: number;
        connectedCaseId: number;
        connectionTypeId: number;
        currentConnectedCases: number[];
        allowWarnings: boolean;
        type: ConnectedCaseActionTypes;
        bowtie?: boolean;
        instanceKey?: string;
      }) =>
        dispatch(actionCreators.onChangeCaseConnection(caseId, connectedCaseId, connectionTypeId, currentConnectedCases, type,
          allowWarnings, bowtie, instanceKey))
    };
  };

  return connect<any, any, any>(undefined, dispatchToProps)(component);
};
